"use client";

import { useActionState } from "react";
import Link from "@/components/AppLink";
import { Alert, Box, Button, Link as MuiLink, Stack, TextField } from "@mui/material";
import PasswordField from "@/components/auth/PasswordField";
import { login, type FormState } from "@/lib/auth/actions";

export default function LoginForm({ next }: { next: string }) {
  const [state, formAction, pending] = useActionState<FormState<"email">, FormData>(login, {});

  return (
    <form action={formAction} noValidate>
      <input type="hidden" name="next" value={next} />
      <Stack spacing={2}>
        {state.error && (
          <Alert severity="error" role="alert">
            {state.error}
          </Alert>
        )}
        <TextField
          name="email"
          type="email"
          label="Email"
          autoComplete="email"
          defaultValue={state.values?.email}
          required
          fullWidth
        />
        <Box>
          <PasswordField name="password" label="Password" autoComplete="current-password" required fullWidth />
          <Box sx={{ textAlign: "right", mt: 0.75 }}>
            <MuiLink component={Link} href="/forgot-password" variant="body2">
              Forgot password?
            </MuiLink>
          </Box>
        </Box>
        <Button type="submit" variant="contained" size="large" disabled={pending} sx={{ py: 1.25 }}>
          {pending ? "Signing in…" : "Sign in"}
        </Button>
      </Stack>
    </form>
  );
}
